import { useEffect, useState } from 'react'
import ReactPixel from 'react-facebook-pixel'
import OPEN_CALL_QUERY from 'graphql/openCall.query'

import ApplyLayout from 'components/ApplyLayout'
import ApplyOpenCallRequirements from 'components/ApplyOpenCall/ApplyOpenCallRequirements'
import ApplyOpenCallNotes from 'components/ApplyOpenCall/ApplyOpenCallNotes'
import ApplyOpenCallTimes from 'components/ApplyOpenCall/ApplyOpenCallTimes'
import ApplyComplete from 'components/ApplyComplete'
import getGlobalSettings from '../../helpers/getGlobalSettings'
import getSites from '../../helpers/getSites'
import StateInitializer from '../../components/StateInitializer'
import { createApolloClient } from '../../lib/createApolloClient'

function OpenCallSteps(props) {
  const { globalSettings, sites } = props
  const [step, setStep] = useState(1)

  useEffect(
    () => {
      if (step === 3) ReactPixel.track('OpenCallEnquiry')
    },
    [step],
  )

  const handleNextStep = e => {
    if (typeof e.preventDefault === 'function') e.preventDefault()
    setStep(step + 1)
  }

  const handlePreviousStep = e => {
    if (typeof e.preventDefault === 'function') e.preventDefault()
    setStep(step - 1)
  }

  return (
    <StateInitializer globalSettings={globalSettings} sites={sites}>
      <ApplyLayout activeArea='open-call'>
        {(() => {
          switch (step) {
            case 4:
              return <ApplyComplete {...props} siteSlug={props.slug} />
            case 3:
              return (
                <ApplyOpenCallTimes
                  next={handleNextStep}
                  back={handlePreviousStep}
                  {...props}
                />
              )
            case 2:
              return (
                <ApplyOpenCallNotes
                  next={handleNextStep}
                  back={handlePreviousStep}
                  {...props}
                />
              )
            default:
              return (
                <ApplyOpenCallRequirements onSubmit={handleNextStep} {...props} />
              )
          }
        })()}
      </ApplyLayout>
    </StateInitializer>
  )
}

export default OpenCallSteps

export async function getStaticProps({ params }) {
  const { slug } = params

  const apolloClient = createApolloClient()

  const [globalSettings, sites, { data, error }] = await Promise.all([
    getGlobalSettings(),
    getSites(),
    apolloClient.query({
      query: OPEN_CALL_QUERY,
      context: { site: slug },
    }),
  ])

  if (error) {
    console.log(`Error loading Open Call props - ${error}`)
  }

  return {
    props: {
      ...params,
      ...data.offices.nodes[0].acfOpenCall,
      globalSettings,
      sites,
    },
    revalidate: 60 * 60 * 24, // Revalidate every 24 hours
  }
}

export async function getStaticPaths() {
  return {
    paths: ['stockholm', 'chicago', 'los-angeles', 'london'].map(site => ({
      params: {
        slug: site,
      },
    })),
    fallback: false,
  }
}
